import script from "./OutputsViewer.vue?vue&type=script&lang=js"
export * from "./OutputsViewer.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__